import { createMessagesModule, getMessagesForCustomer } from '@/store/common-modules/messages';

export default {
  namespaced: true,
  modules: {
    commonMessages: createMessagesModule(getMessagesForCustomer),
  },
  getters: {
  },
  actions: {
  },
};
